(function() {
    'use strict';

    var path = window.location.pathname;
    var isHome = path === '/';
    var isProduct = path.indexOf('/products/') >= 0;
    var isCollection = path.indexOf('/collections/') >= 0;
    var isPage = path.indexOf('/pages/') >= 0;

    // ===== 1. Dynamic SEO Meta Tags =====
    function enhanceSEO() {
        // Remove existing weak meta tags and replace with optimized ones
        var siteName = 'XIDU DIY SHOP';

        var seoData = {
            home: {
                title: 'XIDU DIY Shop | Custom Crystal Bracelets, Music Jewelry & Handmade Accessories',
                description: 'Design your own crystal bracelet with our DIY customizer. Shop handmade music-inspired jewelry, natural crystal bracelets, and unique collectibles. Free shipping over $30.',
                ogImage: 'https://cdn.shopify.com/s/files/1/0741/2278/8942/files/1_1_90e7d365-1311-4634-bb1d-fbf7f7418be5.png'
            },
            product: {
                titlePrefix: ' | XIDU DIY Shop',
                description: 'Handcrafted with natural crystals and premium materials. Custom sizing available. Free shipping on orders over $30.',
                ogImage: null
            },
            collection: {
                titlePrefix: ' Collection | XIDU DIY Shop',
                description: 'Explore our curated collection of handcrafted crystal bracelets and unique jewelry. Custom designs available.',
            },
            default: {
                title: siteName + ' | Custom Crystal Bracelets & Handmade Jewelry',
                description: 'Design your own crystal bracelet with our DIY customizer. Shop handmade music-inspired jewelry and natural crystal bracelets.'
            }
        };

        // Build page-specific title
        var newTitle = seoData.default.title;
        var newDesc = seoData.default.description;
        var ogImage = seoData.home.ogImage;

        if (isHome) {
            newTitle = seoData.home.title;
            newDesc = seoData.home.description;
        } else if (isProduct) {
            var h1 = document.querySelector('h1');
            var productName = h1 ? h1.textContent.trim() : 'Handmade Jewelry';
            newTitle = productName + seoData.product.titlePrefix;
            newDesc = seoData.product.description;
            // Try to get product image for og:image
            var productImg = document.querySelector('.product__media img, .product-form__media img, img[data-product-image]');
            if (productImg && productImg.src) {
                ogImage = productImg.src.replace('_200x', '_1200x').replace('_300x', '_1200x').replace('_400x', '_1200x');
            }
        } else if (isCollection) {
            var collH1 = document.querySelector('h1');
            var collName = collH1 ? collH1.textContent.trim() : 'Collection';
            newTitle = collName + seoData.collection.titlePrefix;
            newDesc = seoData.collection.description;
        } else if (isPage) {
            var pageH1 = document.querySelector('h1');
            var pageName = pageH1 ? pageH1.textContent.trim() : 'Page';
            newTitle = pageName + ' | ' + siteName;
        }

        // Update title
        document.title = newTitle;

        // Update or create meta description
        updateMetaTag('description', newDesc);

        // Update Open Graph tags
        updateMetaProperty('og:title', newTitle);
        updateMetaProperty('og:description', newDesc);
        updateMetaProperty('og:image', ogImage);
        updateMetaProperty('og:url', window.location.href);
        updateMetaProperty('og:site_name', siteName);
        updateMetaProperty('og:type', isProduct ? 'product' : 'website');

        // Update Twitter tags
        updateMetaTag('twitter:title', newTitle, 'name');
        updateMetaTag('twitter:description', newDesc, 'name');
        updateMetaTag('twitter:image', ogImage, 'name');

        // Update theme-color
        updateMetaTag('theme-color', '#1a1410', 'name');

        // Update canonical
        var canonical = document.querySelector('link[rel="canonical"]');
        if (canonical) {
            /* canonical.href override removed - trust Shopify canonical_url */
        }
    }

    function updateMetaTag(name, content, attr) {
        attr = attr || 'name';
        var tag = document.querySelector('meta[' + attr + '="' + name + '"]');
        if (tag) {
            tag.setAttribute('content', content);
        } else {
            tag = document.createElement('meta');
            tag.setAttribute(attr, name);
            tag.setAttribute('content', content);
            document.head.appendChild(tag);
        }
    }

    function updateMetaProperty(prop, content) {
        var tag = document.querySelector('meta[property="' + prop + '"]');
        if (tag) {
            tag.setAttribute('content', content);
        } else {
            tag = document.createElement('meta');
            tag.setAttribute('property', prop);
            tag.setAttribute('content', content);
            document.head.appendChild(tag);
        }
    }

    // ===== 2. JSON-LD Structured Data =====
    function addStructuredData() {
        var scripts = document.querySelectorAll('script[type="application/ld+json"]');
        // Check if we already added our structured data
        for (var i = 0; i < scripts.length; i++) {
            if (scripts[i].getAttribute('data-xidu-seo') === 'true') return;
        }

        var data = {};

        if (isHome) {
            // Organization + WebSite schema
            data = {
                "@context": "https://schema.org",
                "@graph": [
                    {
                        "@type": "Organization",
                        "name": "XIDU DIY SHOP",
                        "url": "https://xidudiy.com",
                        "logo": "https://cdn.shopify.com/s/files/1/0741/2278/8942/files/1_1_90e7d365-1311-4634-bb1d-fbf7f7418be5.png",
                        "description": "Custom crystal bracelets, music-inspired jewelry, and handmade accessories.",
                        "sameAs": [
                            "https://www.tiktok.com/@xidudiy",
                            "https://www.instagram.com/xidudiy",
                            "https://www.pinterest.com/xidudiy"
                        ]
                    },
                    {
                        "@type": "WebSite",
                        "name": "XIDU DIY SHOP",
                        "url": "https://xidudiy.com",
                        "potentialAction": {
                            "@type": "SearchAction",
                            "target": "https://xidudiy.com/search?q={search_term_string}",
                            "query-input": "required name=search_term_string"
                        }
                    }
                ]
            };
        } else if (isProduct) {
            var h1 = document.querySelector('h1');
            var productName = h1 ? h1.textContent.trim() : 'Handmade Jewelry';
            var priceEl = document.querySelector('.price-item--sale, .price-item--regular, [data-product-price]');
            var price = '15.00';
            if (priceEl) {
                var priceMatch = priceEl.textContent.match(/\$?([\d.]+)/);
                if (priceMatch) price = priceMatch[1];
            }
            var imgEl = document.querySelector('.product__media img, .product-form__media img');
            var img = imgEl ? imgEl.src : 'https://cdn.shopify.com/s/files/1/0741/2278/8942/files/1_1_90e7d365-1311-4634-bb1d-fbf7f7418be5.png';

            data = {
                "@context": "https://schema.org",
                "@type": "Product",
                "name": productName,
                "image": img,
                "description": "Handcrafted with natural crystals and premium materials. Custom sizing available.",
                "brand": {
                    "@type": "Brand",
                    "name": "XIDU DIY"
                },
                "offers": {
                    "@type": "Offer",
                    "url": window.location.href,
                    "priceCurrency": "USD",
                    "price": price,
                    "availability": "https://schema.org/InStock"
                }
            };
        } else {
            // Breadcrumb for other pages
            data = {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://xidudiy.com"
                }, {
                    "@type": "ListItem",
                    "position": 2,
                    "name": document.title,
                    "item": window.location.href
                }]
            };
        }

        var script = document.createElement('script');
        script.type = 'application/ld+json';
        script.setAttribute('data-xidu-seo', 'true');
        script.textContent = JSON.stringify(data);
        document.head.appendChild(script);
    }

    // ===== 3. Fix Chinese URL in Blog link =====
    function fixBlogUrl() {
        // Fix footer Blog link that points to /blogs/新闻
        var blogLinks = document.querySelectorAll('a[href*="/blogs/"]');
        blogLinks.forEach(function(link) {
            if (link.href.includes('%E6%96%B0%E9%97%BB') || link.href.includes('/blogs/新闻')) {
                // Update display text
                link.textContent = 'Blog';
                link.title = 'Blog';
                // Note: We can't change the actual URL, but we can redirect it
                link.addEventListener('click', function(e) {
                    e.preventDefault();
                    window.location.href = '/blogs/news';
                });
            }
        });

        // Fix Chinese title attributes
        var allLinks = document.querySelectorAll('a[title]');
        allLinks.forEach(function(link) {
            var title = link.getAttribute('title');
            if (title === '所有商品') link.setAttribute('title', 'All Products');
            if (title === '所有商品系列') link.setAttribute('title', 'All Collections');
            if (title === '新闻') link.setAttribute('title', 'Blog');
        });
    }

    // ===== INIT =====
    function init() {
        /* enhanceSEO() removed - server-side meta tags are authoritative */
        addStructuredData();
        fixBlogUrl();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();